var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"overview"},[_c('h1',[_vm._v("Hello, "+_vm._s(_vm.getUserName()))]),_c('p',{staticClass:"lead"},[_vm._v("Welcome back to your account.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }